// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Закрыть',
  error: () => 'Ошибка',
  warn: () => 'Предупреждение',
  info: () => 'Информация',
  confirmation: () => 'Подтверждение',
  progressIndeterminate: () => 'Выполняется',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'С ' + p['FROM_SECTION'] + ' по ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Соответствующий раздел не найден.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Нажмите Enter, чтобы выбрать значение.',
  indexer_touchInstructionText: () =>
    'Дважды коснитесь и удерживайте, чтобы перейти в режим жестов, затем перетащите вверх или вниз, чтобы изменить значение.',
  inputPassword_show: () => 'Показать пароль',
  inputPassword_hide: () => 'Скрыть пароль',
  inputPassword_hidden: () => 'Пароль скрыт',
  formControl_clear: () => 'Очистить',
  formControl_loading: () => 'Загрузка',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Превышена максимальная длина ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Осталось символов: ' + p['CHARACTER_COUNT'] + '.',
  formControl_requiredMessageDetail: () => 'Введите значение.',
  select_requiredMessageDetail: () => 'Выберите значение.',
  select_noMatchesFound: () => 'Совпадений не найдено.',
  select_oneMatchFound: () => 'Найдено одно совпадение',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Найдено совпадений: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Найдено совпадений: ' + p['TOTAL_SIZE'] + ' или более',
  selectMultiple_selectedValues: () => 'Выбранные значения',
  selectMultiple_showSelectedValues: () => 'Показать только выбранные значения.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Выбрано значений: ' + p['VALUE_COUNT'] + '.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Нажмите клавишу Backspace или Delete, чтобы удалить выбранное значение.',
  selectMultiple_apply: () => 'Применить',
  selectMultiple_back: () => 'Назад',
  selector_selected: () => 'Флажок установлен',
  selector_unselected: () => 'Флажок не установлен',
  userAssistance_learnMore: () => 'Дополнительные сведения',
  userAssistance_required: () => 'Обязательно',
  filePicker_singleFileUploadError: () => 'Загружайте по одному файлу за один раз',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Загрузка файлов типа ' + p['fileType'] + ' невозможна',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Невозможна загрузка файлов следующих типов: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'неизвестно',
  filePicker_dropzonePrimaryText: () => 'Добавьте файлы',
  filePicker_dropzoneSecondaryText: () => 'Выберите или перетащите файл сюда',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Выберите или перетащите файлы сюда',
  filePicker_addFiles: () => 'Добавить файлы',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Увеличить',
  inputNumber_decrease: () => 'Уменьшить',
  inputNumber_converterParseError: () => 'Введите число.',
  noData_message: () => 'Нет элементов для отображения',
  message_navigationFromMessagesRegion: () =>
    'Вход в область сообщений. Нажмите F6 для возврата к предыдущему элементу в фокусе.',
  message_navigationToMessagesRegion: () =>
    'Область сообщений содержит новые сообщения. Нажмите F6 для перехода к последней области сообщений.',
  messageToast_allMessagesClosed: () => 'Все всплывающие сообщения-подсказки закрыты.',
  expandableList_groupCollapse: () => 'Свернуто',
  expandableList_groupExpand: () => 'Развернуто',
  expandableList_expandCollapseInstructionText: () =>
    'Для развертывания и свертывания используйте клавиши со стрелками',
  list_suggestion: () => 'Предложение',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Шаг ' + p['currentStep'] + ' из ' + p['numberOfSteps'],
  train_current: () => 'Текущий',
  train_visited: () => 'Посещено',
  train_not_visited: () => 'Не посещено',
  train_message_type: () => 'Тип сообщения',
  viz_drillable: () => 'С возможностью детализации',
  dataVisualization_stateSelected: () => 'Выбрано',
  dataVisualization_stateUnselected: () => 'Не выбрано',
  dataVisualization_noData: () => 'Нет данных для отображения'
};
export default bundle;
